"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _index = require("../../styles/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledH2 = _styledComponents2.default.h2.withConfig({
  displayName: "H2__StyledH2",
  componentId: "sc-133s8jf-0"
})(["font-family:", ";font-size:20px;font-weight:500;letter-spacing:0px;line-height:32px;margin:0;padding:0;"], _index.fontFamily1);

const H2 = (_ref) => {
  let { children } = _ref,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react2.default.createElement(
    StyledH2,
    props,
    children
  );
};

H2.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.default = H2;